import { render, staticRenderFns } from "./ChildDeviceTable.vue?vue&type=template&id=236f531f&scoped=true"
import script from "./ChildDeviceTable.vue?vue&type=script&lang=ts"
export * from "./ChildDeviceTable.vue?vue&type=script&lang=ts"
import style0 from "./ChildDeviceTable.vue?vue&type=style&index=0&id=236f531f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f531f",
  null
  
)

export default component.exports